// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"417c762a","209":"511fd39a","328":"511fd39a","665":"511fd39a","897":"53dbe695"}[chunkId] + ".chunk.css";
};